// extracted by mini-css-extract-plugin
module.exports = {"reason":"PaymentExemptionReasons_reason__3OTYS","radioButton":"PaymentExemptionReasons_radioButton__24vPh"};